module.exports = __webpack_public_path__ + "img/goback-arrow.57b8df2b.svg";